import React from 'react';
import PropTypes from 'prop-types';

import JSONInput from '../../components/json-input';

import { useTranslation } from 'react-i18next';

import { Grid } from 'semantic-ui-react';

import { Card, HeaderCard, TitleCard, SubTitleCard, ContentCard } from '@weezevent/nacre';

import AceEditor from 'react-ace';
import 'brace/mode/css';
import 'brace/theme/github';

export default function WidgetCustomInputs({ values = {}, css = '', onChange = () => {}, className = '' }) {
    const [_css, setCss] = React.useState(css);
    const [_values, setValues] = React.useState(values);
    const { t } = useTranslation();

    React.useEffect(() => {
        setValues(values);
    }, [values]);

    React.useEffect(() => {
        setCss(css);
    }, [css]);

    const _setValues = React.useCallback(
        value => {
            setValues(value);
            let customs = { ...value, css: _css };
            onChange(customs);
        },
        [_css]
    );

    const _setCss = React.useCallback(
        value => {
            setCss(value);
            let customs = { ..._values, css: value };
            onChange(customs);
        },
        [_values]
    );

    return (
        <Card className={className}>
            <HeaderCard>
                <TitleCard title={t('ticket.widget.custom.card_title')} />
                <SubTitleCard title={t('ticket.widget.custom.card_subtitle')} />
            </HeaderCard>
            <ContentCard>
                <Grid columns={2}>
                    <Grid.Column>
                        <JSONInput
                            style={{
                                width: '100%',
                                minHeight: '100%'
                            }}
                            value={_values}
                            onChange={_setValues}
                        />
                    </Grid.Column>
                    <Grid.Column>
                        <AceEditor
                            mode="css"
                            value={_css}
                            theme="github"
                            onChange={_setCss}
                            editorProps={{ $blockScrolling: true }}
                            style={{
                                width: '100%',
                                height: '200px',
                                border: '1px solid #d4d4d5'
                            }}
                        />
                    </Grid.Column>
                </Grid>
            </ContentCard>
        </Card>
    );
}

WidgetCustomInputs.propTypes = {
    values: PropTypes.object,
    css: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string
};
